var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJava(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 346,
    viewBox: "0 0 256 346",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.5537 267.473C82.5537 267.473 69.3553 275.148 91.9466 277.745C119.315 280.868 133.303 280.42 163.464 274.711C163.464 274.711 171.393 279.683 182.467 283.99C114.855 312.967 29.4481 282.311 82.5537 267.473Z",
    fill: "#5382A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2918 229.658C74.2918 229.658 59.4885 240.616 82.0966 242.954C111.333 245.971 134.421 246.217 174.373 238.524C174.373 238.524 179.899 244.126 188.588 247.19C106.841 271.094 15.7898 249.075 74.2918 229.658Z",
    fill: "#5382A1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M143.941 165.514C160.601 184.694 139.564 201.954 139.564 201.954C139.564 201.954 181.866 180.117 162.439 152.772C144.294 127.27 130.38 114.6 205.706 70.9131C205.706 70.9131 87.4688 100.443 143.941 165.514Z",
    fill: "#E76F00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M233.364 295.442C233.364 295.442 243.131 303.489 222.607 309.715C183.581 321.538 60.1746 325.108 25.893 310.186C13.5696 304.825 36.6794 297.385 43.9489 295.824C51.5302 294.18 55.8626 294.487 55.8626 294.487C42.1578 284.832 -32.7199 313.444 17.8285 321.637C155.681 343.993 269.121 311.571 233.364 295.442Z",
    fill: "#5382A1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9009 190.479C88.9009 190.479 26.1288 205.389 66.6718 210.803C83.7902 213.095 117.916 212.576 149.702 209.913C175.68 207.721 201.765 203.062 201.765 203.062C201.765 203.062 192.605 206.985 185.978 211.51C122.234 228.275 -0.907585 220.476 34.5433 203.327C64.5242 188.835 88.9009 190.479 88.9009 190.479Z",
    fill: "#5382A1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M201.506 253.422C266.305 219.75 236.345 187.392 215.433 191.751C210.307 192.818 208.022 193.742 208.022 193.742C208.022 193.742 209.925 190.761 213.559 189.471C254.929 174.927 286.746 232.368 200.204 255.119C200.204 255.12 201.207 254.223 201.506 253.422Z",
    fill: "#5382A1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M162.438 0.371094C162.438 0.371094 198.325 36.2697 128.401 91.4717C72.33 135.753 115.615 161.001 128.378 189.848C95.6484 160.318 71.6291 134.322 87.7431 110.128C111.395 74.613 176.918 57.3939 162.438 0.371094Z",
    fill: "#E76F00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2684 344.665C157.467 348.647 252.98 342.456 255.242 313.025C255.242 313.025 250.894 324.182 203.838 333.043C150.751 343.033 85.2742 341.867 46.4395 335.464C46.4404 335.463 54.3894 342.044 95.2684 344.665Z",
    fill: "#5382A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJava);
export default __webpack_public_path__ + "static/media/java.d004bc17bfb68228540d36c37e6eb811.svg";
export { ForwardRef as ReactComponent };